<template>
  <div>
    <el-form :model="searchForm" ref="searchForm" label-width="80px">
      <el-row style="margin-top: 20px">
        <el-col :lg="10" :offset="2">
          <el-form-item label="日期:">
            <el-date-picker
              v-model="searchForm.setDate"
              type="daterange"
              range-separator="到"
              start-placeholde="開始日期"
              end-placeholde="結束日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :lg="10">
          <el-form-item label="品牌">
            <el-radio-group v-model="searchForm.brand_id">
              <el-radio :label="1">N牌</el-radio>
              <el-radio :label="2">S牌</el-radio>
              <el-radio :label="3">全部</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :lg="10" :offset="2">
          <el-form-item label="類別:">
            <el-select v-model="searchForm.category">
              <el-option
                v-for="item in options"
                :key="item.label"
                :label="item.label"
                :value="item.label"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="5">
          <el-form-item label="標題:">
            <el-input v-model="searchForm.title" style="width: 70%"></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="1">
          <el-button type="primary" @click="search" icon="el-icon-search">查詢</el-button>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col :offset="20" :lg="2">
        <el-button type="primary" @click="openAdd">新增</el-button>
        <el-dialog title="新增" :visible.sync="diaFormVisible" width="40%" center>
          <div class="dialog">
            <el-form :model="addForm" :rules="rules" ref="addForm" label-width="140px">
              <el-form-item label="標題:" prop="title">
                <el-input v-model="addForm.title" style="width: 50%"></el-input>
              </el-form-item>
              <el-form-item label="類別:" prop="category">
                <el-select v-model="addForm.category">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="品牌(可複選):" prop="brand_id">
                <el-checkbox-group v-model="addForm.brand_id">
                  <el-checkbox
                    v-for="item in brands"
                    :key="item.value"
                    :label="item.label"
                    >{{ item.name }}</el-checkbox
                  >
                </el-checkbox-group>
              </el-form-item>

              <el-form-item label="內容:" prop="content">
                <el-input
                  type="textarea"
                  :rows="6"
                  v-model="addForm.content"
                  style="width: 50%"
                ></el-input>
              </el-form-item>
              <el-form-item label="上傳檔案:">
                <el-upload
                  action="#"
                  ref="upload"
                  :http-request="uploadFileMethod"
                  multiple
                  accept=".jpg,.jpeg,.png,.gif,.bmp,.pdf,.JPG,.JPEG,.PBG,.GIF,.BMP,.PDF"
                  :on-success="handleSuccess"
                  :on-remove="handleRemove"
                  :on-preview="handlePictureCardPreview"
                  :limit="5"
                  :file-list="fileList"
                >
                  <el-button slot="trigger" size="small" type="primary"
                    >選取文件上傳</el-button
                  >
                  <div slot="tip" class="el-upload__tip">檔案必須為 PDF/JPG/PNG 格式</div>
                  <div slot="tip" class="el-upload__tip">圖檔大小不得超過 2MB</div>
                </el-upload>
              </el-form-item>

              <el-row>
                <el-col :lg="8" :offset="10">
                  <el-button @click="closeAdd('addForm')">取 消</el-button>
                  <el-button type="primary" @click="addNotice('addForm')"
                    >確 定</el-button
                  >
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-dialog>
      </el-col>
    </el-row>

    <el-row>
      <el-col :lg="22" :offset="2">
        <el-table
          :data="noticeList.slice((currentPage - 1) * pagesize, currentPage * pagesize)"
          :default-sort="{ prop: 'day', order: 'descending' }"
        >
          <el-table-column label="日期" prop="day" sortable> </el-table-column>
          <el-table-column label="標題" prop="title"> </el-table-column>
          <el-table-column label="品牌" prop="brand_id" align="left">
            <template slot-scope="scope">
              <span v-for="(item, index) in scope.row.brand_id" :key="index">{{
                item == 1 ? "N牌   " : "S牌"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="類別" prop="category"> </el-table-column>
          <el-table-column label="修改">
            <template slot-scope="scope">
              <el-button icon="el-icon-edit" circle @click="edit(scope.row)"></el-button>
              <el-dialog title="編輯" :visible.sync="diaEditVisible" width="40%" center>
                <div class="dialog">
                  <el-form
                    :model="editForm"
                    :rules="editRules"
                    ref="editForm"
                    label-width="140px"
                  >
                    <el-form-item label="標題:" prop="title">
                      <el-input v-model="editForm.title" style="width: 50%"></el-input>
                    </el-form-item>
                    <el-form-item label="類別:" prop="category">
                      <el-select v-model="editForm.category">
                        <el-option
                          v-for="item in options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item label="品牌(可複選):" prop="brand_id">
                      <el-checkbox
                        v-model="editForm.brand_id"
                        v-for="brand in brands"
                        :key="brand.key"
                        :label="brand.label"
                        >{{ brand.name }}</el-checkbox
                      >
                    </el-form-item>

                    <el-form-item label="內容:" prop="content">
                      <el-input
                        type="textarea"
                        :rows="6"
                        v-model="editForm.content"
                        style="width: 50%"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="上傳檔案:">
                      <el-upload
                        action="#"
                        ref="upload"
                        :http-request="uploadFileMethod"
                        multiple
                        accept=".jpg,.jpeg,.png,.gif,.bmp,.pdf,.JPG,.JPEG,.PBG,.GIF,.BMP,.PDF"
                        :on-success="handleSuccess"
                        :on-remove="handleRemove"
                        :on-preview="handlePictureCardPreview"
                        :limit="5"
                        :file-list="url"
                      >
                        <el-button slot="trigger" size="small" type="primary"
                          >選取文件上傳</el-button
                        >
                        <div slot="tip" class="el-upload__tip">
                          檔案必須為 PDF/JPG/PNG 格式
                        </div>
                        <div slot="tip" class="el-upload__tip">圖檔大小不得超過 2MB</div>
                      </el-upload>
                    </el-form-item>

                    <el-row>
                      <el-col :lg="8" :offset="10">
                        <el-button @click="closeEdit('editForm')">取 消</el-button>
                        <el-button type="primary" @click="updateNotice('editForm')"
                          >確 定</el-button
                        >
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </el-dialog>
            </template>
          </el-table-column>
          <el-table-column label="刪除">
            <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-delete"
                circle
                @click="deleteNotice(scope.row)"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total1"
          @current-change="current_change"
        >
        </el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
export default {
  name: "notice",

  data() {
    return {
      searchForm: {
        setDate: [],
        brand_id: null,
        category: null,
        title: "",
      },
      addForm: {
        title: "",
        category: "",
        brand_id: [],
        content: "",
        files: [],
      },
      editForm: {},
      brands: [
        { label: 1, name: "N牌", value: 1 },
        { label: 2, name: "S牌", value: 2 },
      ],
      total1: 0,
      currentPage: 1,
      pagesize: 10,
      fileList: [],
      startDate: "",
      endDate: "",
      fileKey: "",
      files: [],
      noticeList: [],
      open: false,
      url: [],
      diaFormVisible: false,
      diaEditVisible: false,
      options: [
        { label: "公告", value: "公告" },
        { label: "活動", value: "活動" },
        { label: "DM", value: "DM" },
      ],
      rules: {
        title: [{ required: true, message: "請輸入標題" }],
        category: [{ required: true, message: "請選擇類別", trigger: "change" }],
        brand_id: [{ required: true, message: "請點選品牌", trigger: "change" }],
        content: [{ required: true, message: "請填寫內容" }],
      },
      editRules: {
        title: [{ required: true, message: "請輸入標題" }],
        category: [{ required: true, message: "請選擇類別" }],
        brand_id: [{ required: true, message: "請點選品牌" }],
        content: [{ required: true, message: "請填寫內容" }],
      },
    };
  },
  computed: mapGetters([
    "getNoticeList",
    "getNoticeKey",
    "getNoticeError",
    "getNoticeMsg",
    "getNoticeDetail",
    "getNoticeFile",
  ]),
  methods: {
    ...mapActions([
      "fetchNoticeList",
      "fetchNoticeDetail",
      "addNoticeFile",
      "addNotice",
      "updateNotice",
      "LoadFile",
    ]),
    async search() {
      if (this.searchForm.setDate.length != 0) {
        this.startDate = moment(this.searchForm.setDate[0]).format("YYYY-MM-DD");
        this.endDate = moment(this.searchForm.setDate[1]).format("YYYY-MM-DD");
      }
      const data = await {
        brand_id: this.searchForm.brand_id,
        title: this.searchForm.title,
        category: this.searchForm.category,
        day_from: this.startDate,
        day_to: this.endDate,
      };
      await this.$store.dispatch("fetchNoticeList", data);
      this.noticeList = this.getNoticeList;
      this.total1 = this.noticeList.length;
    },
    async addNotice(formName) {
      const data = {
        title: this.addForm.title,
        brand_id: this.addForm.brand_id,
        category: this.addForm.category,
        content: this.addForm.content,
        file: this.files,
      };
      await this.$store.dispatch("addNotice", data);
      if (this.getNoticeError != true) {
        this.$notify({
          title: "成功",
          message: "新增最新消息成功",
          type: "success",
          duration: "4500",
          position: "top-right",
        });
        this.$refs[formName].resetFields();
        this.fileList = [];
        this.diaFormVisible = false;
      } else {
        this.$notify({
          title: "失敗",
          message: this.getNoticeMsg,
          type: "error",
          duration: "4500",
          position: "top-right",
        });
      }
    },
    async updateNotice(formName) {
      const data = {
        _key: this.editForm._key,
        title: this.editForm.title,
        brand_id: this.editForm.brand_id,
        category: this.editForm.category,
        content: this.editForm.content,
        file: this.files,
      };
      await this.$store.dispatch("updateNotice", data);
      if (this.getNoticeError != true) {
        this.$notify({
          title: "成功",
          message: "編輯最新消息成功",
          type: "success",
          duration: "4500",
          position: "top-right",
        });
        this.$refs[formName].resetFields();
        this.editForm = this.addForm;
        this.url = [];
        this.diaEditVisible = false;
      } else {
        this.$notify({
          title: "失敗",
          message: this.getNoticeMsg,
          type: "error",
          duration: "4500",
          position: "top-right",
        });
      }
    },
    async deleteNotice(row) {
      const data = { _key: row._key };
      await this.$store.dispatch("deleteNotice", data);
      if (this.getNoticeError != true) {
        this.$notify({
          title: "成功",
          message: this.getNoticeMsg,
          type: "success",
          duration: "4500",
          position: "top-right",
        });
      } else {
        this.$notify({
          title: "失敗",
          message: "刪除失敗",
          type: "error",
          duration: "4500",
          position: "top-right",
        });
      }
    },
    async edit(row) {
      this.diaEditVisible = true;
      const data = { _key: row._key };
      await this.$store.dispatch("fetchNoticeDetail", data);
      this.editForm = this.getNoticeDetail;
      this.fetchFile(this.editForm.file);
    },
    async closeEdit(formName) {
      this.diaEditVisible = false;
      this.url = [];
      await this.$refs[formName].resetFields();
    },
    async closeAdd(formName) {
      this.diaFormVisible = false;
      this.fileList = [];
      await this.$refs[formName].resetFields();
    },
    async fetchFile(file) {
      for (let i = 0; i < file.length; i++) {
        await this.$store.dispatch("LoadFile", file[i]._key);
        let src = await window.URL.createObjectURL(this.getNoticeFile);
        this.url.push({
          _key: file[i]._key,
          url: src,
          name: file[i].name,
        });
      }
    },
    async uploadFileMethod(param) {
      let fileObject = param.file;
      let formData = new FormData();
      formData.append("file", fileObject, fileObject.name);

      await this.$store.dispatch("addNoticeFile", formData);
      this.fileKey = await this.getNoticeKey;
      await this.files.push(this.fileKey);
    },
    async uploadEditFileMethod(param) {
      let fileObject = param.file;
      let formData = new FormData();
      formData.append("file", fileObject);

      await this.$store.dispatch("addNoticeFile", formData);
      this.fileKey = await this.getNoticeKey;
      await this.editForm.files.push(this.fileKey);
    },
    handleBeforeUpload(file) {
      console.log("before");
      if (
        !(
          file.type === "image/png" ||
          file.type === "image/gif" ||
          file.type === "image/jpg" ||
          file.type === "image/jpeg"
        )
      ) {
        this.$notify.warning({
          title: "警告",
          message: "請上傳格式為 image/png, image/gif, image/jpg, image/jpeg的圖片",
        });
      }
      let size = file.size / 1024 / 1024 / 2;
      if (size > 2) {
        this.$notify.warning({
          title: "警告",
          message: "圖片大小必須小於2M",
        });
      }
    },
    current_change: function (currentPage) {
      this.currentPage = currentPage;
    },
    // 文件超出个数限制时的钩子
    handleExceed(files, fileList) {},

    // 文件列表移除文件时的钩子
    handleRemove(file, fileList) {},
    // 点击文件列表中已上传的文件时的钩子
    handlePictureCardPreview(file) {
      console.log(file);
      document.location.href = file.url;
    },
    handleSuccess(response, file, fileList) {
      this.$notify({
        title: "成功",
        message: "上傳圖片成功",
        type: "success",
        duration: "4500",
        position: "top-right",
      });
    },
    uploadFile() {
      this.$refs.upload.submit();
    },

    async openAdd() {
      this.diaFormVisible = await true;
    },
  },
};
</script>

<style lang="scss" scoped>
dialog {
  height: 60vh;
  overflow: auto;
}
</style>
